import { ITlfActionSetReadOnly, TlfContextProps } from "./interface";

/**
 * Updates whether the current TLF is read-only for the user.
 *
 * @param state - Current TLF context state.
 * @param action - Set-read-only action containing the next read-only flag.
 * @returns Updated state with the read-only flag changed.
 */
export const tlf_setTlfReadOnly = (
  state: TlfContextProps,
  action: ITlfActionSetReadOnly,
): TlfContextProps => ({
  ...state,
  readOnly: action.readOnly,
});
